/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { REPLACING_FILE, UPLOADING_FILE } from 'components/FileUpload/paramsByState';
import { useFetchBamCommercialFamilyCodes } from 'domains/bamCommercialFamilyCodes/BamCommercialFamilyCodes.requests';

import { getBamCommercialFamilyCodesFileUploadStatus } from 'domains/bamCommercialFamilyCodes/BamCommercialFamilyCodes.store';

import BamCommercialFamilyCodesFileUpload from 'pages/BackOfficePage/BackOfficeCategories/BamCommercialFamilyCodes/BamCommercialFamilyCodesFileUpload';
import FileRows from 'pages/BackOfficePage/BackOfficeCategories/BamCommercialFamilyCodes/FileRows';
import { Flex, MarginBox, Text } from 'UI';

const BamCommercialFamilyCodes = () => {
  const { t } = useTranslation();
  useFetchBamCommercialFamilyCodes();

  const fileUploadStatus = useSelector(getBamCommercialFamilyCodesFileUploadStatus);

  const bamCommercialFamilyCodes = useFetchBamCommercialFamilyCodes();

  const showRows =
    bamCommercialFamilyCodes?.length > 0 && fileUploadStatus !== UPLOADING_FILE && fileUploadStatus !== REPLACING_FILE;

  return (
    <Flex direction={'column'} align={'center'}>
      <MarginBox mt={64}>
        <Text type="heading3">
          {t('backoffice.bam_commercial_family_codes.title', 'Upload list of commercial family codes')}
        </Text>
        <Text type="base">
          {t(
            'backoffice.bam_commercial_family_codes.description',
            'Upload a list of commercial family codes to define Motrio references compatible with other brand vehicles. Once uploaded, the system will link the references, allowing the "BAM" logo to be displayed on the frontend. Please ensure your file follows the required format before submitting.',
          )}
        </Text>
        <Text type="base">
          {t(
            'backoffice.bam_commercial_family_codes.upload_file.description',
            'Maximum file size : 2 MB - (Accepted formats : .csv)',
          )}
        </Text>
        <BamCommercialFamilyCodesFileUpload bamCommercialFamilyCodes={bamCommercialFamilyCodes} />

        {showRows && (
          <MarginBox mt={50}>
            <Text type="heading3">
              {t('backoffice.bam_commercial_family_codes.uploaded_codes.title', 'Commercial family codes')}
            </Text>
            <MarginBox mt={20}>
              <Text type="base">
                {t(
                  'backoffice.bam_commercial_family_codes.uploaded_codes.description',
                  'The "BAM" logo to be displayed on Rpartstore Website, for the following Commercial families.',
                )}
              </Text>
            </MarginBox>
            <MarginBox mt={30}>
              <FileRows fileRows={bamCommercialFamilyCodes} />
            </MarginBox>
          </MarginBox>
        )}
      </MarginBox>
    </Flex>
  );
};

export default BamCommercialFamilyCodes;
